import { render } from "./EventsDetail.vue?vue&type=template&id=7c1e020e&scoped=true"
import script from "./EventsDetail.vue?vue&type=script&lang=js"
export * from "./EventsDetail.vue?vue&type=script&lang=js"

import "./EventsDetail.vue?vue&type=style&index=0&id=7c1e020e&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\Tegra\\abrafarma\\abrafarma-app-ionic-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1e020e"]])

export default __exports__